import React from "react";

const Loader = () => <img alt="loading" src="/assets/images/loader.svg" />;

export default Loader;
